// @ts-nocheck
export const handleDownload = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const handleDownloadExcel = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', url);
  document.body.appendChild(link);
  link.click();
};

export const handleRemoveFile = (file, fileAttach, setFileAttach) => {
  const updatedFiles = fileAttach?.filter((i) => i?.id !== file?.id);
  setFileAttach(updatedFiles);
};

export const handleRemoveImage = (photo, setImageAttach, imageAttach) => {
  const updatedImage = imageAttach?.filter((i) => i?.id !== photo?.id);
  setImageAttach(updatedImage);
};

export const onSuccess = (data, setImageFileAttachment) => {
  setImageFileAttachment((prevState) => [...prevState, ...(data || [])]);
};

export const onFailure = (err, setValues) => {
  setValues('');
};

export const attachmentHandler = (
  files,
  saveAttachment,
  getFormData,
  onSuccess,
  onFailure,
) => {
  if (files) {
    saveAttachment(getFormData(files), null, null, onSuccess, onFailure);
  }
};
